// extracted by mini-css-extract-plugin
module.exports = {"wrapperIcon":"WrapperIcon_wrapperIcon__3DT5F"};